import { InlineSvg } from 'components/svg';
import { FC } from 'react';

interface DownloadLinkProps {
  text: string;
  link: string;
}

export const DownloadLink: FC<DownloadLinkProps> = ({ text, link }) => {
  const handleClick = () => {
    window.open(link, '_blank');
  };

  return (
    <span className="badge badge-light-secondary fw-bolder" role="button" onClick={handleClick}>
      {text} <InlineSvg path="/media/svg/general/download.svg" svgClassName="ms-1" />
    </span>
  );
};
